import FormV3InputField from "./FormFieldsV3/FormV3InputField";
import FormV3TextAreaField from "./FormFieldsV3/FormV3TextAreaField";
import FormV3CheckboxField from "./FormFieldsV3/FormV3CheckboxField";
import FormV3RadioField from "./FormFieldsV3/FormV3RadioField";
import FormV3SelectField from "./FormFieldsV3/FormV3SelectField";
import FormV3DateField from "./FormFieldsV3/FormV3DateField";
import FormV3TableField from "./FormFieldsV3/FormV3TableField";
import { FormV3ListTable } from "./FormFieldsV3/FormV3ListTable";
import React from "react";
import { ListTableValidator } from "./FormV3Utils/types";
import FormV3UploadField from "./FormFieldsV3/FormV3UploadField";

type RenderFormFieldExtra = {
   isQuestionnaire?: boolean;
   listTable?: {
      listSelections: Record<string, string[]>;
      setListSelections: React.Dispatch<React.SetStateAction<Record<string, string[]>>>;
      setIsRecordEditing: (isRecordEditing: boolean) => void;
      hasCheckboxColumnById: Record<string, boolean>;
      setHasCheckboxForListTable: (fieldId: string, has: boolean) => void;
      registerListTableValidator?: (listTableFieldId: string, fn: ListTableValidator) => void;
      unregisterListTableValidator?: (listTableFieldId: string) => void;
   };
};

export const renderFormField = (
   field,
   formGUID,
   loading,
   handleFieldValueChange,
   intl,
   extra?: RenderFormFieldExtra,
   formId?: string,
) => {
   if (field === null) return;
   if (!field?.type) return <span> {intl.formatMessage({ id: "global.fieldTypeError" })}</span>;
   if (
      field?.type === "UUID" ||
      field?.type === "String" ||
      field?.type === "Number" ||
      field?.type === "Decimal"
   ) {
      if (field.type === "String" && extra?.isQuestionnaire) {
         return (
            <FormV3TextAreaField
               field={field}
               formGUID={formGUID}
               onValueChange={handleFieldValueChange}
            />
         );
      }
      return (
         <FormV3InputField
            field={field}
            formGUID={formGUID}
            type={field?.type}
            loading={loading}
            decorators={field?.decorators}
            onValueChange={handleFieldValueChange}
         ></FormV3InputField>
      );
   } else if (field?.type === "Boolean" || field?.type === "Checkbox") {
      return (
         <FormV3CheckboxField
            field={field}
            formGUID={formGUID}
            decorators={field?.decorators}
            onValueChange={handleFieldValueChange}
            loading={loading}
            isQuestionnaire={extra?.isQuestionnaire}
         />
      );
   } else if (field?.type === "Radio") {
      return (
         <FormV3RadioField
            field={field}
            formGUID={formGUID}
            onValueChange={handleFieldValueChange}
            loading={loading}
            isQuestionnaire={extra?.isQuestionnaire}
         />
      );
   } else if (field?.type === "Section") {
      return (
         <div className="form-builder-section" style={{ margin: 0 }}>
            <div className="form-builder-section-header">
               <div className="form-builder-section-title">{field?.label}</div>
            </div>
         </div>
      );
   } else if (field?.type === "Select" || field?.type === "MultiSelect") {
      return (
         <FormV3SelectField
            field={field}
            formGUID={formGUID}
            decorators={field?.decorators}
            isMulti={field?.type === "MultiSelect"}
            onValueChange={handleFieldValueChange}
            loading={loading}
         ></FormV3SelectField>
      );
   } else if (field?.type === "File") {
      return (
         <FormV3UploadField
            field={field}
            formGUID={formGUID}
            onValueChange={handleFieldValueChange}
            formId={formId}
         />
      );
   } else if (field?.type === "LocalDate" || field?.type === "LocalDateTime") {
      return (
         <FormV3DateField
            field={field}
            formGUID={formGUID}
            decorators={field?.decorators}
            onValueChange={handleFieldValueChange}
            loading={loading}
         ></FormV3DateField>
      );
   } else if (
      field?.type === "List" &&
      (field?.persistenceData?.multiplicity === "PLURAL" ||
         field?.modelField?.multiplicity === "PLURAL")
   ) {
      return (
         <FormV3TableField
            field={field}
            formGUID={formGUID}
            decorators={field?.decorators}
         ></FormV3TableField>
      );
   } else if (field.type === "ListTable") {
      const cfg = extra?.listTable;
      if (!cfg) return <span style={{ color: "red" }}>Missing listTable config</span>;

      return (
         <FormV3ListTable
            field={field}
            formGUID={formGUID}
            selectedIds={cfg.listSelections[field.id] ?? []}
            onSelectionChange={(nextIds) =>
               cfg.setListSelections((prev) => ({ ...prev, [field.id]: nextIds }))
            }
            setIsRecordEditing={cfg.setIsRecordEditing}
            hasCheckboxColumnById={cfg.hasCheckboxColumnById}
            setHasCheckboxForListTable={cfg.setHasCheckboxForListTable}
            registerListTableValidator={cfg.registerListTableValidator}
            unregisterListTableValidator={cfg.unregisterListTableValidator}
         />
      );
   } else {
      return <span style={{ color: "red" }}>{`Not supported type: ${field?.type}`}</span>;
   }
};
